import { BaseButton } from 'components/menu-button/MenuButton';
import { GlobeIcon } from 'components/icon/Icon';
import { useIntl } from 'react-intl';
import { SiteLocale } from 'utils/i18n';
import { useRouter } from 'next/router';

interface LanguageSwitcherProps {
  locale: SiteLocale;
  isTablet: boolean | undefined;
}

const LanguageSwitcher = ({ locale, isTablet }: LanguageSwitcherProps) => {
  const router = useRouter();

  const handleRoute = (locale: SiteLocale) => {
    router.push(`/`, undefined, {
      locale: locale === 'en' ? 'is' : 'en',
    });
    //  router.push(`${router.asPath}`, undefined, {
    //    locale: locale === 'en' ? 'is' : 'en',
    //  })
  };
  const { formatMessage } = useIntl();

  return (
    <BaseButton variant="clear" handleOnClick={() => handleRoute(locale)}>
      <GlobeIcon />
      {!isTablet ? (
        <span>
          {formatMessage({
            id: 'language_switch_label',
            defaultMessage: 'EN',
          })}
        </span>
      ) : null}
    </BaseButton>
  );
};

export default LanguageSwitcher;
